interface Array<T> {
  distinct(): T[];
  remove(item: T): boolean;
  removeEvery(predicate: (item: T) => boolean): void;
  /**
   * @deprecated Use `arr.flatMap(predicate)` instead
   */
  selectMany<U>(predicate: (item: T) => U[]): U[];
  groupBy(func: (x: T) => string, orderFunc?: (x: T) => number): Grouping<T>[];
  equals(e: T[]): boolean;
}
interface Grouping<T> {
  key: string;
  values: T[];
  order?: number;
}
(function <T>() {

  if (!Array.prototype.equals) {
    Array.prototype.equals = function (this: T[], b: T[]) {
      if (this.length !== b.length) { return false; }
      const uniqueValues = new Set([...this, ...b]);
      for (const v of uniqueValues) {
        const aCount = this.filter(e => e === v).length;
        const bCount = b.filter(e => e === v).length;
        if (aCount !== bCount) { return false; }
      }
      return true;
    };
  }
  if (!Array.prototype.distinct) {
    Array.prototype.distinct = function (this: T[]) {
      return this.filter((v, i, a) => a.indexOf(v) === i);
    };
  }

  if (!Array.prototype.remove) {
    Array.prototype.remove = function (this: T[], item: T): boolean {
      const index = this.indexOf(item);
      if (index >= 0) {
        this.splice(index, 1);
        return true;
      }
      return false;
    };
  }

  if (!Array.prototype.removeEvery) {
    Array.prototype.removeEvery = function (this: T[], predicate: (item: T) => boolean) {
      const items = this.filter(x => predicate(x));
      for (const item of items) {
        this.remove(item);
      }
    };
  }

  if (!Array.prototype.selectMany) {
    Array.prototype.selectMany = function <U>(this: T[], predicate: (item: T) => U[]) {
      return this.map(predicate).reduce((a, b) => a.concat(b), []);
    };
  }

  if (!Array.prototype.groupBy) {
    Array.prototype.groupBy = function (this: T[], keyFunction: (item: T) => string, orderFunc: (item: T) => number): Grouping<T>[] {
      const groups = new Map<string, Grouping<T>>()

      for (const el of this) {
        const key = keyFunction(el);
        let group = groups.get(key);
        if (!group) {
          const inferredOrder = orderFunc ? orderFunc(el) : (el as any)?.order;
          group = { key, values: [], order: inferredOrder };
          groups.set(key, group);
        }
        group.values.push(el);
      }

      return Array.from(groups.values());
    };
  }
})();
